import { render, staticRenderFns } from "./MyFirstDataWizard.vue?vue&type=template&id=5e416da7&scoped=true"
import script from "./MyFirstDataWizard.vue?vue&type=script&lang=js"
export * from "./MyFirstDataWizard.vue?vue&type=script&lang=js"
import style0 from "./MyFirstDataWizard.vue?vue&type=style&index=0&id=5e416da7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e416da7",
  null
  
)

export default component.exports